const useAddressService = () => {
    return {
        addressByCep: (cep) => fetch(`https://viacep.com.br/ws/${cep}/json/`).then((response) => response.json())
    };
};

export default useAddressService;
